var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.5 64C50.1731 64 64.5 49.6731 64.5 32C64.5 14.3269 50.1731 0 32.5 0C14.8269 0 0.5 14.3269 0.5 32C0.5 49.6731 14.8269 64 32.5 64ZM45.5681 27.5109C47.0162 26.1847 47.115 23.9356 45.7887 22.4875C44.4624 21.0393 42.2134 20.9406 40.7652 22.2668L27.6379 34.2897L24.2348 31.1729C22.7867 29.8467 20.5376 29.9454 19.2113 31.3935C17.885 32.8416 17.9838 35.0907 19.4319 36.417L25.2364 41.7332C26.5954 42.9778 28.6802 42.9778 30.0393 41.7332L45.5681 27.5109Z",
    fill: "#4ECB71"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check_circle.7f20324b8b515ec780b66ac7ffbde263.svg";
export { ForwardRef as ReactComponent };